module.exports = __webpack_public_path__ + "static/apple-icon-114x114-533f85cbe4497db857876b1b88021b96.png";